<!-- Always mounted: toggle visibility so Ctrl/⌘F paints in the same frame. -->
<div
  class="menu-search-backdrop"
  [class.open]="open()"
  [attr.inert]="open() ? null : ''"
  [attr.aria-hidden]="open() ? null : 'true'"
  role="presentation"
  (click)="onBackdropClick($event)"
>
  <div
    class="menu-search-panel"
    role="dialog"
    aria-modal="true"
    aria-label="Search menu"
    (click)="$event.stopPropagation()"
  >
    <div class="menu-search-field">
      <mat-icon class="menu-search-field-icon" aria-hidden="true">search</mat-icon>
      <input
        #queryInput
        type="search"
        class="menu-search-input"
        placeholder="Search menu & pages…"
        autocomplete="off"
        spellcheck="false"
        [attr.tabindex]="open() ? 0 : -1"
        [ngModel]="query"
        (ngModelChange)="onQueryChange($event)"
        (keydown)="onInputKeydown($event)"
        aria-autocomplete="list"
        aria-controls="menu-search-results"
        [attr.aria-activedescendant]="
          results[activeIndex] ? 'menu-search-option-' + activeIndex : null
        "
      />
      <kbd class="menu-search-kbd">esc</kbd>
    </div>

    <ul
      id="menu-search-results"
      class="menu-search-results"
      role="listbox"
      aria-label="Search results"
    >
      @for (hit of results; track trackByKey($index, hit); let i = $index) {
        @if (sectionLabelAt(i); as section) {
          <li class="menu-search-section" role="presentation">{{ section }}</li>
        }
        <li
          role="option"
          [id]="'menu-search-option-' + i"
          class="menu-search-result"
          [class.active]="i === activeIndex"
          [class.recent]="hit.kind === 'recent'"
          [attr.aria-selected]="i === activeIndex"
          (mouseenter)="activeIndex = i"
          (click)="select(hit)"
        >
          <span class="menu-search-result-glyph" aria-hidden="true"></span>
          <div class="menu-search-result-text">
            <span class="menu-search-result-label">{{ hitLabel(hit) }}</span>
            @if (hitParent(hit); as parent) {
              <span class="menu-search-result-parent">{{ parent }}</span>
            }
          </div>
          @if (hit.kind === 'recent') {
            <span class="menu-search-result-badge" aria-hidden="true">Page</span>
          }
          <span class="menu-search-result-hint" aria-hidden="true">↵</span>
        </li>
      } @empty {
        <li class="menu-search-empty" role="presentation">No matching pages</li>
      }
    </ul>

    <div class="menu-search-footer" aria-hidden="true">
      <span><kbd>↑</kbd><kbd>↓</kbd> navigate</span>
      <span><kbd>↵</kbd> open</span>
      <span><kbd>esc</kbd> close</span>
    </div>
  </div>
</div>
